'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _InjectionMapping = require('./InjectionMapping');

var _InjectionMapping2 = _interopRequireDefault(_InjectionMapping);

var _stringToObject = require('./stringToObject');

var _stringToObject2 = _interopRequireDefault(_stringToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Injector = function () {
    function Injector(parentInjector) {
        (0, _classCallCheck3.default)(this, Injector);

        this._mappings = {};
        this._parentInjector = null;
        this.map('injector').toValue(this);
        this._parentInjector = parentInjector || null;
    }

    (0, _createClass3.default)(Injector, [{
        key: '_createMapping',
        value: function _createMapping(type, name, id) {
            if (this._hasOwnMapping(type, name)) {
                throw new Error('Already has mapping for ' + type);
            }

            var mapping = new _InjectionMapping2.default(type, name, id);
            this._mappings[id] = mapping;

            return mapping;
        }
    }, {
        key: '_getMappingID',
        value: function _getMappingID(type) {
            var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            // eslint-disable-line class-methods-use-this
            return type + '|' + name;
        }
    }, {
        key: '_hasOwnMapping',
        value: function _hasOwnMapping(type, name) {
            var mappingID = this._getMappingID(type, name);
            return this._mappings[mappingID] !== undefined;
        }
    }, {
        key: '_postConstruct',
        value: function _postConstruct(object) {
            // eslint-disable-line class-methods-use-this
            /* eslint-disable no-nested-ternary */
            var postConstructs = object.postConstructs !== undefined ? object.postConstructs instanceof Array ? object.postConstructs : [] : [];
            /* eslint-enable no-nested-ternary */
            var index = void 0;
            var methodName = void 0;
            var method = void 0;
            /* eslint-disable guard-for-in */
            // $FlowFixMe should refactor this code once we know what it should be
            for (index in postConstructs) {
                // eslint-disable-line no-restricted-syntax
                // $FlowFixMe should refactor this code once we know what it should be
                methodName = postConstructs[index];
                method = object[methodName] === undefined ? null : object[methodName];

                if (typeof method === 'function') {
                    method.apply(object);
                }
            }
            /* eslint-enable guard-for-in */
        }
    }, {
        key: 'map',
        value: function map(type, name) {
            var mappingID = this._getMappingID(type, name);
            return this._mappings[mappingID] || this._createMapping(type, name, mappingID);
        }
    }, {
        key: 'unmap',
        value: function unmap(type, name) {
            if (this.hasMapping(type, name)) {
                var mappingID = this._getMappingID(type, name);
                delete this._mappings[mappingID];
            } else {
                var nameError = name === undefined ? '' : ' by name ' + name;
                throw new Error('Cannot unmap "' + type + nameError + '" because no mapping has been found');
            }
        }
    }, {
        key: 'hasMapping',
        value: function hasMapping(type, name) {
            return this._hasOwnMapping(type, name) || this._parentInjector != null && this._parentInjector.hasMapping(type, name);
        }
    }, {
        key: 'hasDirectMapping',
        value: function hasDirectMapping(type, name) {
            return this._hasOwnMapping(type, name);
        }
    }, {
        key: 'getInstance',
        value: function getInstance(type, name) {
            if (!this.hasMapping(type, name)) {
                var nameError = name === undefined ? '' : ' by name ' + name;
                throw new Error('Cannot return instance "' + type + nameError + '" because no mapping has been found');
            }

            return this.getMapping(type, name).getValue();
        }
    }, {
        key: 'getMapping',
        value: function getMapping(type, name) {
            var _this = this;

            if (!this.hasMapping(type, name)) {
                var nameError = name === undefined ? '' : ' by name ' + name;
                throw new Error('Mapping "' + type + nameError + '" was not found');
            }

            var mappingID = this._getMappingID(type, name);
            return this._mappings[mappingID] !== undefined ? this._mappings[mappingID] : function () {
                var parent = _this.getParentInjector();
                if (!(parent instanceof Injector)) {
                    throw new Error('Could not get parent injector');
                }
                return parent.getMapping(type, name);
            }();
        }
    }, {
        key: 'injectInto',
        value: function injectInto(object) {
            /* eslint-disable guard-for-in, no-param-reassign */
            for (var member in object) {
                // eslint-disable-line no-restricted-syntax
                var injectionObject = (0, _stringToObject2.default)(member, object[member]);

                if (injectionObject != null) {
                    if (this.hasMapping(injectionObject.type, injectionObject.name)) {
                        object[member] = this.getInstance(injectionObject.type, injectionObject.name);
                    } else {
                        throw new Error('Cannot inject ' + injectionObject.type + ' into ' + object + ' due to a missing rule');
                    }
                }
            }
            /* eslint-enable guard-for-in, no-param-reassign */

            this._postConstruct(object);
        }
    }, {
        key: 'teardown',
        value: function teardown() {
            this._mappings = {};
            this.map('injector').toValue(this);
        }
    }, {
        key: 'getParentInjector',
        value: function getParentInjector() {
            return this._parentInjector;
        }
    }, {
        key: 'setParentInjector',
        value: function setParentInjector(parentInjector) {
            if (parentInjector != null && !(parentInjector instanceof Injector)) {
                throw new Error('Cannot set the parentInjector because it is not an injector');
            }

            this._parentInjector = parentInjector;
        }
    }, {
        key: 'createChildInjector',
        value: function createChildInjector() {
            return new Injector(this);
        }
    }]);
    return Injector;
}();

exports.default = Injector;
//# sourceMappingURL=Injector.js.map